import React, { Component } from 'react';
import { Input, Form,Row, Col, Modal, Button,Select, message } from 'antd';
import { Message } from 'semantic-ui-react'
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

const TextArea = Input.TextArea;
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 12 },
};
class CopMeetingAndTrainingApplyRecordModalDialog extends Component {

    refreshQuery() {
        const {
            userName,
            status
        } = this.props.meetingAndTrainingApplyRecordQueryFields;
        this.props.loadMeetingAndTrainingApplyRecordInfo({userName, status})
    }

    componentDidUpdate() {
        const {
            copMeetingAndTrainingApplyRecordStatus,
        } = this.props;
        if(copMeetingAndTrainingApplyRecordStatus === ACTION_STATUS.SUCCESS) {
            message.success('CopAll User Access Info succeeded');
            this.props.initCopMeetingAndTrainingApplyRecordActionStatus();
            this.props.resetCopMeetingAndTrainingApplyRecordModal();
            this.refreshQuery();
        }
        if(copMeetingAndTrainingApplyRecordStatus === ACTION_STATUS.ERROR) {
            this.props.initCopMeetingAndTrainingApplyRecordActionStatus();
        }
    }


    onInputChange = ({name, value}) => {
        this.props.copMeetingAndTrainingApplyRecordChangeInput({name, value});
    }


    submitCopMeetingAndTrainingApplyRecord = () => {
        Modal.confirm({
            title: 'Are you sure copy access to select?',
            onOk: () => {
            
                const {
                    id,
                    employee,
                    comments,
                } = this.props.copMeetingAndTrainingApplyRecordModal.fields;
                this.props.copMeetingAndTrainingApplyRecord({id, employee, comments});
            },
            onCancel: () => {},
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            copMeetingAndTrainingApplyRecordModal,
            copMeetingAndTrainingApplyRecordStatus,
            userAccountOptions,
        } = this.props;
        const {
            isOpened,
            respErrMsg,
        } = copMeetingAndTrainingApplyRecordModal;

        const {
            comments,
            employee,
        } = copMeetingAndTrainingApplyRecordModal.fields

        const isSubmitLoading = copMeetingAndTrainingApplyRecordStatus === ACTION_STATUS.LOGINING;
        

        return (
            <div>
                <Modal
                    title={'Copy ALL User Access Info'}
                    centered
                    width={500}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetCopMeetingAndTrainingApplyRecordModal()}
                    footer={[
                        <Button key="back" onClick={() => this.props.resetCopMeetingAndTrainingApplyRecordModal()}>
                          Close
                        </Button>,
                        <Button key="save" type="primary" loading={isSubmitLoading} onClick={this.submitCopMeetingAndTrainingApplyRecord}>
                          Submit
                        </Button>,
                      ]}
                >
                <Row gutter={24}>
                    <Col span={12}>
                            <FormItem {...formItemLayout} label="Employee">
                            {getFieldDecorator('employee', {
                                initialValue: employee,
                                rules: [{
                                    required: true,
                                    message: 'Please select Employee',
                                }],
                                })(
                                <Select
                                        allowClear
                                        showSearch
                                        style={{ width: 200, marginLeft: 10 }}
                                        onChange={(val) => {
                                            this.onInputChange({ name: 'employee', value: val })
                                        }} 
                                        placeholder="Please select Employee">
                                    {userAccountOptions}
                                </Select>
                                )}
                            </FormItem>
                    </Col>
                </Row> 
                <Row gutter={24}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="Comments">
                        {getFieldDecorator('comments', {
                            initialValue: comments,
                            rules: [{
                                required: false,
                                message: 'Please input Comments',
                            }],
                            })(
                            <TextArea 
                                style={{ width: 200, marginLeft: 10 }}
                                rows={3} 
                                onChange={(e) => {
                                    this.onInputChange({ name: 'comments', value: e.target.value })
                                }}
                            />
                            )}
                        </FormItem>
                    </Col>
                </Row> 



                    {
                    !!respErrMsg &&  
                    <Message negative>
                        <Message.Header>Response Error Message</Message.Header>
                        <p>{ respErrMsg }</p>
                    </Message>
                    }
                </Modal>
                
            </div>
            
        );
    }

}

const CopMeetingAndTrainingApplyRecordModalDialogForm = Form.create({ name: 'CopMeetingAndTrainingApplyRecordModalDialog' })(CopMeetingAndTrainingApplyRecordModalDialog);
export default CopMeetingAndTrainingApplyRecordModalDialogForm;
